"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWithinRange = exports.isBefore = void 0;

var _dateString = require("./date-string");

var _timeString = require("./time-string");

/**
 * This module contains utilities that work with date strings in the format
 * "YYYY-MM-DD HH:mm". These functions are much faster than the full-featured
 * functions from the date-fns library, so use them when possible.
 */

/**
 * Returns the year, month, day, hour, and minutes of a date time string as integers.
 * If you only need hour and minutes, consider using `parseTimeString` from "_utils/time-string"
 * parseDateTimeString("2018-10-31 02:00") -> {year: 2018, month: 10, day: 31, hour: 2, minutes: 0}
 */
var parseDateTimeString = function parseDateTimeString(dateTimeString) {
  var _parseTimeString = (0, _timeString.parseTimeString)(dateTimeString),
      hour = _parseTimeString.hour,
      minutes = _parseTimeString.minutes;

  return {
    year: (0, _dateString.getYear)(dateTimeString),
    month: (0, _dateString.getMonth)(dateTimeString),
    day: (0, _dateString.getDay)(dateTimeString),
    hour: hour,
    minutes: minutes
  };
};
/**
 * Returns a unitless number that can be used to compare one date with another
 * chronologically. This in abstract way of doing this, but it's much faster than
 * actually parsing the dates and comparing them that way.
 */


var getComparable = function getComparable(date) {
  var _parseDateTimeString = parseDateTimeString(date),
      year = _parseDateTimeString.year,
      month = _parseDateTimeString.month,
      day = _parseDateTimeString.day,
      hour = _parseDateTimeString.hour,
      minutes = _parseDateTimeString.minutes;

  return year * 100000000 + month * 1000000 + day * 10000 + hour * 100 + minutes;
};
/**
 * Returns true if a date falls in the range identified by a start and an end
 * date. Faster than date-fns when dealing with string dates.
 */


var isWithinRange = function isWithinRange(date, start, end) {
  var startComparable = getComparable(start);
  var endComparable = getComparable(end);
  var dateComparable = getComparable(date);
  return dateComparable > startComparable && dateComparable < endComparable;
};
/**
 * Returns true if a comes before b. Faster than date-fns when dealing with
 * string dates.
 */


exports.isWithinRange = isWithinRange;

var isBefore = function isBefore(a, b) {
  return getComparable(a) < getComparable(b);
};

exports.isBefore = isBefore;